const SUPPORTED_TAG_NAMES = ["a", "div", "img"];

const isInsideFencedCode = (source, index) => {
  let activeFence = "";

  for (const line of source.slice(0, index).split("\n")) {
    const match = line.match(/^\s{0,3}(`{3,}|~{3,})/);
    if (!match) continue;

    const marker = match[1][0];
    if (!activeFence) {
      activeFence = marker;
    } else if (activeFence === marker) {
      activeFence = "";
    }
  }

  return Boolean(activeFence);
};

const findUnclosedElement = (source, tagName, validateOpening = () => true) => {
  const lowerSource = source.toLowerCase();
  const openingIndex = lowerSource.lastIndexOf(`<${tagName}`);
  const closingIndex = lowerSource.lastIndexOf(`</${tagName}>`);

  if (
    openingIndex < 0 ||
    openingIndex < closingIndex ||
    isInsideFencedCode(source, openingIndex)
  ) {
    return -1;
  }

  const openingEnd = source.indexOf(">", openingIndex);
  const opening = source.slice(
    openingIndex,
    openingEnd < 0 ? source.length : openingEnd + 1,
  );
  return validateOpening(opening) ? openingIndex : -1;
};

const findPartialTag = (source) => {
  const openingIndex = source.lastIndexOf("<");
  if (openingIndex < 0 || source.indexOf(">", openingIndex) >= 0) return -1;
  if (isInsideFencedCode(source, openingIndex)) return -1;

  const token = source
    .slice(openingIndex + 1)
    .replace(/^\//, "")
    .trimStart()
    .split(/\s/, 1)[0]
    .toLowerCase();

  if (!token) return -1;
  return SUPPORTED_TAG_NAMES.some((tagName) => tagName.startsWith(token))
    ? openingIndex
    : -1;
};

export const prepareMixedMarkdownForRender = (content = "") => {
  const source = String(content || "");
  if (!source.includes("<")) return source;

  const candidates = [
    findUnclosedElement(source, "a"),
    findUnclosedElement(source, "div", (opening) =>
      /\bimage-wrapper(?:1|4)\b/i.test(opening),
    ),
    findPartialTag(source),
  ].filter((index) => index >= 0);

  return candidates.length > 0 ? source.slice(0, Math.min(...candidates)) : source;
};
